import {getFormattedDate} from 'src/utils'

const defaultValues = {
	formName: 'Invoice',
	from: {
		name: 'Business Name',
		email: 'business_email@gmail.com',
		address1: 'Company address 1',
		address2: 'Company address 2',
		city: 'City name',
		state: 'State',
		zip: '12345',
		phone: '(123) 1231230',
		businessNumber: '(123) 1231230',
	},
	to: {
		name: 'Client Name',
		email: 'client_email@gmail.com',
		address1: 'Client address 1',
		address2: 'Client address 2',
		city: 'City name',
		state: 'State',
		zip: '12345',
		phone: '(123) 1231230',
	},

	number: 'INV1023',
	date: getFormattedDate(),
}

export default defaultValues
